import StateOffcanvas from '../Offcanvas'
import { GroupSelect } from 'GroupSelect'
import { Accordion } from 'react-bootstrap'
import NamedCheckbox from '../NamedCheckbox'
import { v4 } from 'uuid'
import { useSettings } from 'Settings'

const Vaux = ({id}) => {
	const [settings] = useSettings()
	const vaux = settings['vaux'][id]

	const vaux_options = [
		{ value : 0, label : "STS" },
		{ value : 1, label : "LDO" },
		{ value : 2, label : "Auto-floating" },
		{ value : 3, label : "Auto-grounded" }
	]

	return (
		<Accordion.Item eventKey={id}>
			<Accordion.Header>VAUX {id}</Accordion.Header>
			<Accordion.Body>
				<NamedCheckbox
					name="Enable"
					value={vaux['enable'].value}
					onChange={(e) => vaux['enable'].setValue(e.target.checked)}
				/>
				<NamedCheckbox
					name="Disable in HRV_LOW mode"
					value={vaux['disable in hrv_low mode'].value}
					onChange={(e) => vaux['disable in hrv_low mode'].setValue(e.target.checked)}
				/>
				<GroupSelect
					name="Constantly connect to"
					options={vaux_options}
					value={vaux['constantly connect to'].value}
					onChange={(e) => vaux['constantly connect to'].setValue(e.value)}
				/>
			</Accordion.Body>
		</Accordion.Item>
	)
}

const VauxGnd = ({id}) => {
	const [settings] = useSettings()
	const vaux_gnd = settings['vaux gnd'][id]

	const vaux_gnd_options = [
		{ value : 0, label : "Manual" },
		{ value : 1, label : "Auto-disconnect" }
	]

	return (
		<Accordion.Item eventKey={id}>
			<Accordion.Header>VAUX GND {id}</Accordion.Header>
			<Accordion.Body>
				<NamedCheckbox
					name="Enable"
					value={vaux_gnd['enable'].value}
					onChange={(e) => vaux_gnd['enable'].setValue(e.target.checked)}
				/>
				<NamedCheckbox
					name="Open in HRV_LOW mode"
					value={vaux_gnd['open in hrv_low mode'].value}
					onChange={(e) => vaux_gnd['open in hrv_low mode'].setValue(e.target.checked)}
				/>
				<GroupSelect
					name="Connection"
					options={vaux_gnd_options}
					value={vaux_gnd['connection'].value}
					onChange={(v) => vaux_gnd['connection'].setValue(v.value)}
				/>
			</Accordion.Body>
		</Accordion.Item>
	)
}

export function PurplePanel({ handle, onHide }) {
	return (
		<StateOffcanvas handle={handle} onHide={onHide} trigger="purple" title="VAUX Settings">
			<Accordion className="mb-3">
				{[0, 1, 2].map((id) => (<Vaux key={v4()} id={id} />))}
			</Accordion>
			<Accordion className="mb-3">
				{[0, 1, 2].map((id) => (<VauxGnd key={v4()} id={id} />))}
			</Accordion>
		</StateOffcanvas>
	)
}
